import api from './'

export default {

    /**
     * Show payment intent
     * @param paymentIntentId
     * @param params
     */
    show(paymentIntentId, params) {
        return api
            .get(`/paymentIntents/${paymentIntentId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get payment intents
     * @param params
     */
    get(params) {
        return api
            .get(`/paymentIntents`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update a payment intent
     * @param id
     * @param data
     */
    update(id, data) {
        return api
            .put(`/paymentIntents/${id}`, data)
            .then((response) => {
                return response.data
            });
    },

    /**
     * Retry
     * @param id
     * @param data
     */
    retry(id, data) {
        return api
            .post(`/paymentIntents/${id}/restart`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Refund
     * @param id
     * @param data
     */
    refund(id, data) {
        return api
            .post(`/paymentIntents/${id}/refund`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Add payment transaction
     * @param id
     * @param data
     */
    addPaymentTransactions(id, data) {
        return api
            .post(`/paymentIntents/${id}/paymentTransactions`, data)
            .then(response => {
                return response.data
            })
    },

}
